import { render, staticRenderFns } from "./PagosMultasSelect.vue?vue&type=template&id=b0284788&"
import script from "./PagosMultasSelect.vue?vue&type=script&lang=js&"
export * from "./PagosMultasSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports